module.exports = __webpack_public_path__ + "static/img/process.15ff57b3.svg";